export default "__VITE_ASSET__LyvKRF5G__"